import { PortalClassesEnum } from "@/ts/enums/PortalClassesEnum";
import { getTrackingId } from "@/utils/utils";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Flex, Link } from "@chakra-ui/react";

import { isActiveUrl } from "@utils/utils";

interface Props {
    linkText: string;
    url: string;
    isExternal?: boolean;
    dataTrackingName?: string;
}

const NavItem = ({ linkText, url, isExternal, dataTrackingName }: Props) => {
    // Checks whether the provided URL corresponds to the current page.
    const isActive = url && !isExternal ? isActiveUrl(url) : false;

    return (
        <>
            <Link
                href={url}
                target={isExternal ? "_blank" : "_self"}
                fontWeight="600"
                color={isActive ? "gray.800" : "gray.600"}
                display="inline-flex"
                flexDirection="column"
                alignItems="center"
                transition="color 0.2s ease"
                textDecor="none"
                data-tracking-id={getTrackingId(
                    [PortalClassesEnum.Link],
                    dataTrackingName ?? ""
                )}
                position="relative"
                _after={{
                    content: "''",
                    position: "absolute",
                    bottom: "-5px",
                    left: "50%",
                    transform: isActive
                        ? "translateX(-50%) scaleX(1)"
                        : "translateX(-50%) scaleX(0)",
                    backgroundColor: "burntYellow.500",
                    width: "2rem",
                    height: "3px",
                    borderRadius: "3px",
                    transformOrigin: "center",
                    transition: "transform 0.2s ease"
                }}
                _hover={{
                    color: "gray.800",
                    _dark: { color: "gray.200" },
                    _after: {
                        transform: "translateX(-50%) scaleX(1)"
                    }
                }}
                _active={{
                    color: "gray.800",
                    _dark: { color: "gray.200" },
                    _after: {
                        transform: "scaleX(1)",
                        backgroundColor: "burntYellow.500"
                    }
                }}
                _dark={{
                    color: isActive ? "gray.200" : "gray.400"
                }}
                aria-current={isActive ? "page" : undefined}
            >
                <Flex
                    as="span"
                    display="inline-flex"
                    alignItems="center"
                    gap="0.5rem"
                >
                    {linkText}
                    {isExternal && (
                        <FontAwesomeIcon
                            icon={faUpRightFromSquare}
                            width="12px"
                            height="12px"
                            data-testid="externalImg"
                        />
                    )}
                </Flex>
            </Link>
        </>
    );
};

export default NavItem;
